import { createTheme } from "@mui/material";
import { deepOrange, lightGreen, orange, yellow } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    primary: yellow,
    secondary: orange,
    mode: "dark",
  },
});
